module.exports = __webpack_public_path__ + "static/media/sword-laser.69bf503e.svg";